import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "c-text-and-video-section__inner" }
const _hoisted_3 = { class: "c-text-and-video-section__content" }
const _hoisted_4 = { class: "c-text-and-video-section__media" }

import { computed } from 'vue';
import { RichText, Text as JssText } from '@sitecore-jss/sitecore-jss-vue';
import AdaptiveMedia from '@/elements/AdaptiveMedia.vue';
import type { TextAndVideoSectionProps } from '@/types/components/TextAndVideoSection';
import utils from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'TextAndVideoSection',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;

const fields = computed(() => props.fields);
const rendering = computed(() => props.rendering);
const mediaField = computed(() => fields.value?.video);
const hasMedia = computed(() => {
  const mediaFields = mediaField.value?.fields;

  return !!(
    mediaFields?.desktopImage?.value?.src ||
    mediaFields?.mobileImage?.value?.src ||
    mediaFields?.desktopVideo?.value?.src ||
    mediaFields?.desktopVideo?.value?.href ||
    mediaFields?.mobileVideo?.value?.src ||
    mediaFields?.mobileVideo?.value?.href
  );
});

const rootClass = computed(() =>
  utils.overall.baseComClass(props.fields, 'c-text-and-video-section')
);
const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});

return (_ctx: any,_cache: any) => {
  const _component_JssRichText = _resolveComponent("JssRichText")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value),
        id: rendering.value?.dataSource
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_JssRichText, {
                  class: "c-text-and-video-section__title",
                  field: fields.value?.title,
                  tag: "h2"
                }, null, 8, ["field"]),
                (fields.value.description?.value)
                  ? (_openBlock(), _createBlock(_unref(RichText), {
                      key: 0,
                      class: "c-text-and-video-section__description",
                      field: fields.value.description
                    }, null, 8, ["field"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_4, [
                (hasMedia.value)
                  ? (_openBlock(), _createBlock(AdaptiveMedia, {
                      key: 0,
                      field: mediaField.value,
                      ratio: 1.78,
                      "show-play-button": true,
                      autoplay: false,
                      loop: false,
                      controls: true,
                      "has-controls": true,
                      "is-background": ""
                    }, null, 8, ["field"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})